import React from "react";
import * as BiIcons from "react-icons/bi";

function SearchBox(props: any) {
  const { onChange, value } = props;
  return (
    <div className="ui icon input search-bar">
      <input
        placeholder="Search"
        type="text"
        value={value}
        name="search"
        onChange={onChange}
      />

      <i aria-hidden="true" className="search circular inverted link icon">
        <BiIcons.BiSearchAlt2 />
      </i>
    </div>
  );
}

export default React.memo(SearchBox);
